
export default function TrustStatement() {
  return (
    <section className="bg-[#1C1C1E] py-24">
      <div className="max-w-4xl mx-auto px-8 text-center">
        <div className="w-16 h-px bg-[#C8A14A] mx-auto mb-8"></div>
        <p className="font-serif text-3xl md:text-4xl text-[#F7F5F2] leading-relaxed">
          Built exclusively for law firms that demand discretion, reliability, and operational excellence.
        </p>
        <div className="w-16 h-px bg-[#C8A14A] mx-auto mt-8"></div>
      </div>
    </section>
  );
}
